import InstalledDetail from './installedDetail';

export default InstalledDetail;   